import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AuditLogsAPI from '../../api/auditLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    perPage: 25,
    totalEntries: 0,
  },
  uiFlags: {
    fetchingList: false,
    fetchError: null,
  },
  requestId: 0,
  accountId: null,
  loadedPage: null,
};

const getters = {
  getAuditLogs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
};

const actions = {
  async fetch(
    { commit, state: currentState, rootGetters },
    { page, filters = {} } = {}
  ) {
    // Pagina e filtros juntos identificam a lista: a mesma pagina com outro
    // filtro e outra lista, e o erro nao pode manter as linhas antigas.
    const requestKey = JSON.stringify({ page: Number(page ?? 1), filters });
    const accountId = rootGetters?.getCurrentAccountId ?? null;
    const requestId = currentState.requestId + 1;
    const accountChanged = currentState.accountId !== accountId;
    const isCurrent = () =>
      currentState.requestId === requestId &&
      currentState.accountId === accountId &&
      rootGetters?.getCurrentAccountId === accountId;

    commit(types.default.SET_AUDIT_LOGS_REQUEST_CONTEXT, {
      requestId,
      accountId,
    });
    if (accountChanged) {
      commit(types.default.SET_AUDIT_LOGS, []);
      commit(types.default.SET_AUDIT_LOGS_META, {
        totalEntries: 0,
        perPage: 25,
        currentPage: 1,
      });
      commit(types.default.SET_AUDIT_LOGS_LOADED_PAGE, null);
    }
    commit(types.default.SET_AUDIT_LOGS_UI_FLAG, {
      fetchingList: true,
      fetchError: null,
    });
    try {
      const response = await AuditLogsAPI.get({ page, filters });
      if (!isCurrent()) return [];
      const { audit_logs: logs = [] } = response.data;
      const {
        total_entries: totalEntries,
        per_page: perPage,
        current_page: currentPage,
      } = response.data;
      commit(types.default.SET_AUDIT_LOGS, logs);
      commit(types.default.SET_AUDIT_LOGS_META, {
        totalEntries,
        perPage,
        currentPage,
      });
      commit(types.default.SET_AUDIT_LOGS_LOADED_PAGE, requestKey);
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      if (isCurrent()) {
        const status = error?.response?.status;
        if ([401, 403, 404].includes(status)) {
          commit(types.default.SET_AUDIT_LOGS, []);
          commit(types.default.SET_AUDIT_LOGS_LOADED_PAGE, null);
          commit(types.default.SET_AUDIT_LOGS_META, {
            totalEntries: 0,
            perPage: 25,
            currentPage: 1,
          });
        } else if (currentState.loadedPage !== requestKey) {
          commit(types.default.SET_AUDIT_LOGS, []);
          commit(types.default.SET_AUDIT_LOGS_LOADED_PAGE, null);
        }
        commit(types.default.SET_AUDIT_LOGS_UI_FLAG, {
          fetchingList: false,
          fetchError: true,
        });
      }
      return throwErrorMessage(error);
    }
  },
  invalidate({ commit, state: currentState }) {
    commit(types.default.SET_AUDIT_LOGS_REQUEST_CONTEXT, {
      requestId: currentState.requestId + 1,
      accountId: currentState.accountId,
    });
  },
};

const mutations = {
  [types.default.SET_AUDIT_LOGS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_AUDIT_LOGS]: MutationHelpers.set,
  [types.default.SET_AUDIT_LOGS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.default.SET_AUDIT_LOGS_REQUEST_CONTEXT](_state, data) {
    _state.requestId = data.requestId;
    _state.accountId = data.accountId;
  },
  [types.default.SET_AUDIT_LOGS_LOADED_PAGE](_state, page) {
    _state.loadedPage = page;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
